import { Select } from "chakra-react-select";
import { useEffect, useState } from "react";
import { VendorList } from "../interfaces/defaultInterfaces";
import VendasRecorrentesApi from "../services/vendasRecorrentesApi";
import { ToLocaleFormat } from "../defaultFunctions/formaters";

export default function PlanosRecorrenciaSelect({ plano, setPlano }: any) {
  const [vendorList, setVendorList] = useState(Array<VendorList>);
  const [search, setSearch] = useState("");
  const [plans, setPlans] = useState({
    key: 0,
    value: 0,
    label: "",
  });

  async function getListaPlanosRecorrencia() {
    try {
      const response = await VendasRecorrentesApi.getListaPlanosRecorrencia(
        1,
        800,
        0
      );
      console.log("response do select de planos recorrencia", response.data);
      setVendorList(response.data);
    } catch (error) {
      console.log("error", error);
    }
  }

  useEffect(() => {
    getListaPlanosRecorrencia();
  }, [search]);

  const vendorOptions =
    vendorList &&
    vendorList.map((plan) => {
      return {
        key: plan.idPlano,
        value: plan.idPlano,
        label: `${plan.nome} - ${
          plan.frequencia === "monthly"
            ? "Mensal"
            : plan.frequencia === "daily"
            ? "Diária"
            : plan.frequencia === "weekly"
            ? "Semanal"
            : "Anual"
        } - ${ToLocaleFormat(plan.valor / 100)}`,
      };
    });

  function onChangeInput(item: any) {
    setSearch(item);
  }

  function onChangeClientFilter(e: any) {
    setPlano(e.value);
    setPlans(e);
  }

  return (
    <Select
      name="colors"
      options={vendorOptions}
      // value={id ? plans : null}
      placeholder="Selecionar Plano de Recorrência"
      closeMenuOnSelect={true}
      onChange={(e: any) => {
        onChangeClientFilter(e);
      }}
      onInputChange={(e: any) => {
        onChangeInput(e);
      }}
    />
  );
}
